import React, { useMemo } from 'react';
import { Route, Routes } from 'react-router-dom';

import { extractEnabledPaths, filterRoutes } from '@app/dev/components/router/helper';

const generateRoutes = (routes) => routes.map(({
  path,
  element,
  index,
  children,
}) => (
  <Route key={path || 'index'} path={path} element={element} index={index}>
    {children && generateRoutes(children)}
  </Route>
));

export const FilteredRoutes = ({ routeDefs }) => {
  const allowedPaths = extractEnabledPaths();
  const filtered = useMemo(() => filterRoutes(routeDefs, allowedPaths), [routeDefs, allowedPaths]);

  console.log(allowedPaths, filtered, 'filtered');

  return <Routes>{generateRoutes(filtered)}</Routes>;
};
